module.exports = __webpack_public_path__ + "img/cb3a352.svg";